<div class="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col max-h-full overflow-hidden">

  <!-- Header -->
  <div class="p-4 border-b border-gray-200 shrink-0">
    <h2 class="text-lg font-semibold text-gray-800">{{ title() }}</h2>
  </div>

  <!-- Llista de dies -->
  <div class="overflow-y-auto p-4 space-y-2 custom-scrollbar min-h-0">
    @if (scheduleSummary().daily.length) {
      @for (item of scheduleSummary().daily; track item.date) {
        <div class="flex items-center justify-between p-3 pl-1 rounded-lg hover:bg-gray-50 transition-colors cursor-default border border-transparent hover:border-gray-100">
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 flex flex-col items-center justify-center text-blue-600">
              <span class="text-lg font-bold leading-none">{{ item.dayNumber }}</span>
            </div>
            <div class="flex flex-col">
              <span class="text-gray-900 text-sm font-medium leading-tight capitalize">{{ item.dayName }}</span>
              <span class="text-gray-500 text-xs capitalize">{{ item.monthYear }}</span>
            </div>
          </div>
          <div class="flex items-baseline gap-1">
            <span class="text-gray-900 font-bold text-lg">
              {{ item.hours }}<span class="text-xs font-bold text-gray-600">h</span>
            </span>
            <span class="text-gray-900 font-bold text-lg">
              {{ item.minutes }}<span class="text-xs font-bold text-gray-600">min</span>
            </span>
          </div>
        </div>
      }
    } @else {
      <div class="flex flex-col items-center justify-center h-48 text-gray-400">
        <lib-icon name="calendar" class="w-12 h-12 mb-3 opacity-20"></lib-icon>
        <p class="text-sm">No hay riegos</p>
      </div>
    }
  </div>

  <!-- Footer total -->
  <div class="p-4 bg-gray-50 border-t border-gray-200 rounded-b-xl space-y-3 shrink-0">
    <div class="flex items-center justify-between">
      <span class="text-gray-600 text-sm">Días de riego</span>
      <span class="text-gray-900 font-semibold">{{ scheduleSummary().totalDays }}</span>
    </div>
    <div class="flex items-center justify-between pt-3 border-t border-gray-200">
      <span class="text-blue-900 font-bold text-sm">Total</span>
      <div class="flex items-baseline gap-1">
        <span class="text-2xl font-bold text-blue-900">
          {{ scheduleSummary().totalHours }}<span class="text-sm">h</span> {{ scheduleSummary().totalMinutes }}<span class="text-sm">min</span>
        </span>
      </div>
    </div>
  </div>

</div>